import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { EmployeeSystem } from 'src/app/Interfaces/hr/employee-system';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { EmployeeService } from 'src/app/shared/services/hr/employee.service';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';

@Component({
  selector: 'app-employee-systems-data',
  templateUrl: './employee-systems-data.component.html',
  styleUrls: ['./employee-systems-data.component.scss']
})
export class EmployeeSystemsDataComponent implements OnInit {
  employeeSystemData:any={}
  subscribe:Subscription
  employeeid:number
  employeeSystemid:number
  workSystemSetting:{text:string,value:number}[]=[
    {
      text:this.translate.instant('personnelaffairs.default'),
      value:1
    },
    {
      text:this.translate.instant('personnelaffairs.employee'),
      value: 2
    },
    {
      text:this.translate.instant('personnelaffairs.worksystem'),
      value:3
    }
  ]
  buttonOptions = {
    text: this.translate.instant('employeeduration.submit'),
    type: 'default',
    useSubmitBehavior: true,
  };

   // loading
   loading:boolean=false

  constructor( public gt: genericCustomStoreService, public _EmployeeService: EmployeeService,public router:Router,public NotifyService:NotifyService,
    public translate:TranslateService) {
    // _EmployeeService.$DROPDOWNSETTING.next(this.workSystemSetting)
    this.subscribe= this._EmployeeService.$EMPLOYEE_ID.subscribe(res => this.employeeid = res)
    if (this.employeeid != 0) {
      this.loading=true;
      this._EmployeeService.EmployeeSystems(this.employeeid).then((res:EmployeeSystem) => {
        this.employeeSystemData=res   
        this.loading=false;
      })
   }
  }

  ngOnInit(): void {}
  onFormSubmit(e:any){    
    e.preventDefault()
     let data={
      ...this.employeeSystemData
     }
    this._EmployeeService.EditEmployeeSystems(data).subscribe(res=>{
      this.NotifyService.notifyfun('edit')
      this.router.navigate(['hr/EmployeeSystems'])
    })  
  }
  // backToMainPage(e:string){
  //   if(e=='back'){
  //     this.router.navigate(['/hr/EmployeeSystems'])
  //   }
  // }
}
